import type React from "react";

type Props = {
  width: number;
  height: number;
  bgImage: string;
  backgroundPosition?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

/**
 * iOS-safe background wrapper for html-to-image exports.
 * Safari often drops CSS `background-image` during canvas/SVG rasterization.
 */
export const GraphicBackground = ({
  width,
  height,
  bgImage,
  backgroundPosition = "center",
  style,
  children,
}: Props) => {
  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        fontFamily: "'Nunito', sans-serif",
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: backgroundPosition,
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
};
